(function () {
  'use strict';
  let current;
  const alias = {rings:'engagement-rings',bands:'wedding-bands'};
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    root.dsController = controller;
    const on = (element, event, handler, options = {}) => element?.addEventListener(event, handler, {...options,signal:controller.signal});
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const header = $('.shop-header');
    const mega = $('#ds-mega');
    const mobile = $('#ds-mobile-nav');
    const search = $('#ds-header-search');
    const scrim = $('.nav-scrim');
    const narrow = matchMedia('(max-width:1000px)');
    const usesProductRoutes = typeof window.DS_PRODUCT_ROUTE === 'function';
    const previewThemeId = usesProductRoutes
      ? (window.DS_PREVIEW_CONFIG?.isPreview !== false ? window.DS_PREVIEW_CONFIG?.themeId : null)
      : (root.dataset.previewMode === 'true' ? root.dataset.themeId : null);
    let active = '', timer, focusTimer, returnFocus, measureFrame = 0;
    const main = document.getElementById('main');
    if (main && !main.hasAttribute('tabindex')) main.tabIndex = -1;
    const syncDialogLock = () => document.documentElement.classList.toggle('ds-header-dialog-open',Boolean(document.querySelector('[data-ds-shared-header] dialog[open]')));
    const route = value => {
      // Product routes retain the current commerce runtime's locale/draft rules.
      if (usesProductRoutes) return window.DS_PRODUCT_ROUTE(value);
      if (!value || value.startsWith('#') || /^(mailto:|tel:)/i.test(value)) return value;
      let url;
      try { url = new URL(value, location.origin); } catch { return value; }
      if (![location.hostname,'diamondstudio.com','www.diamondstudio.com','diamondstudio.myshopify.com'].includes(url.hostname)) return value;
      if (root.dataset.previewMode === 'true') {
        url.searchParams.set('preview_theme_id', root.dataset.themeId);
        if (url.pathname === (root.dataset.homeUrl || '/') || url.pathname.startsWith('/products/')) url.searchParams.set('view','ds-preview');
      } else {
        url.searchParams.delete('preview_theme_id');
        if (url.searchParams.get('view') === 'ds-preview') url.searchParams.delete('view');
        const localeRoot = root.dataset.homeUrl || window.Shopify?.routes?.root || '/';
        // Add the current locale only to bare Shopify storefront routes.
        // Already localized paths, including links to another locale, stay intact.
        const bareStorefrontPath = url.pathname === '/' || /^\/(products|collections|pages|blogs|policies|search|cart|account)(\/|$)/.test(url.pathname);
        if (localeRoot !== '/' && !url.pathname.startsWith(localeRoot) && bareStorefrontPath) url.pathname = localeRoot.replace(/\/$/,'') + url.pathname;
      }
      return url.pathname + url.search + url.hash;
    };
    $$('a[href]').forEach(link => { link.href = route(link.getAttribute('href')); });
    function hide(restore = false) {
      clearTimeout(timer);
      cancelAnimationFrame(measureFrame);
      measureFrame = 0;
      const previous = active;
      active = '';
      if (mega) mega.hidden = true;
      if (scrim) scrim.hidden = true;
      $$('[data-dsh-mega]').forEach(button => button.setAttribute('aria-expanded','false'));
      if (restore) $$('[data-dsh-mega]').find(button => button.dataset.dshMega === previous)?.focus();
    }
    function closeDialog(dialog, restore = true) {
      if (!dialog?.open) return;
      dialog.close();
      syncDialogLock();
      if (restore && returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
    }
    function closeAll(restore = false) {
      hide(restore);
      closeDialog(mobile,restore);
      closeDialog(search,restore);
    }
    function mobilePage(key) {
      $('[data-dsh-mobile-home]').hidden = Boolean(key);
      $$('[data-dsh-mobile-panel]').forEach(panel => { panel.hidden = panel.dataset.dshMobilePanel !== key; });
      const scrollArea = $('#ds-mobile-inner') || mobile;
      scrollArea.scrollTop = 0;
      if (key) $('[data-dsh-mobile-panel="'+CSS.escape(key)+'"] [data-dsh-mobile-back]')?.focus();
    }
    function show(key, keyboard = false) {
      if (controller.signal.aborted || !root.isConnected) return;
      clearTimeout(timer);
      key = alias[key] || key;
      if (!$$('[data-dsh-panel]').some(panel => panel.dataset.dshPanel === key)) key = $$('[data-dsh-panel]')[0]?.dataset.dshPanel;
      if (!key) return;
      measure();
      if (narrow.matches) {
        hide();
        returnFocus = document.activeElement;
        mobilePage(key);
        if (!mobile.open) mobile.showModal();
        document.documentElement.classList.add('ds-header-dialog-open');
        $('[data-dsh-mobile-panel="'+CSS.escape(key)+'"] [data-dsh-mobile-back]')?.focus();
        return;
      }
      active = key;
      $$('[data-dsh-panel]').forEach(panel => { panel.hidden = panel.dataset.dshPanel !== key; });
      mega.hidden = false;
      if (scrim) scrim.hidden = false;
      $$('[data-dsh-mega]').forEach(button => button.setAttribute('aria-expanded',String(button.dataset.dshMega === key)));
      if (keyboard) $('[data-dsh-panel="'+CSS.escape(key)+'"] a')?.focus();
    }
    on(root,'click',event => {
      const target = event.target.closest('button,a');
      if (!target) return;
      if (target.matches('[data-dsh-mega]')) { active === target.dataset.dshMega ? hide() : show(target.dataset.dshMega); return; }
      if (target.matches('[data-dsh-mobile-open]')) {
        hide(); returnFocus = target; mobilePage(''); mobile.showModal();
        document.documentElement.classList.add('ds-header-dialog-open'); return;
      }
      if (target.matches('[data-dsh-mobile-section]')) { mobilePage(target.dataset.dshMobileSection); return; }
      if (target.matches('[data-dsh-mobile-back]')) {
        const previous = target.closest('[data-dsh-mobile-panel]')?.dataset.dshMobilePanel;
        mobilePage(''); $$('[data-dsh-mobile-section]').find(button => button.dataset.dshMobileSection === previous)?.focus(); return;
      }
      if (target.matches('[data-dsh-close]')) { closeAll(true); return; }
      if (target.matches('[data-search-open],[data-saved-open],[data-open-finder]')) {
        closeAll();
        if (target.matches('[data-search-open]')) {
          if (!usesProductRoutes && root.dataset.previewMode === 'true' && document.getElementById('search-dialog')) return;
          // Homepage 21 also delegates search clicks on document. Stop this click
          // here so the shared search always uses the complete Shopify catalog.
          event.preventDefault();
          event.stopPropagation();
          returnFocus = target.getClientRects().length ? target : $$('[data-search-open]').find(button => button.getClientRects().length) || $('[data-dsh-mobile-open]');
          if (!search.open) search.showModal();
          syncDialogLock();
          search.querySelector('input[name="q"]')?.focus();
          return;
        }
        const dialogId = target.matches('[data-saved-open]') ? 'saved-dialog' : 'finder-dialog';
        // Let Homepage 21's own interaction handler open its saved pieces/finder.
        const homeDialog = document.getElementById(dialogId);
        if (homeDialog) {
          if (!target.getClientRects().length) {
            const selector = dialogId === 'saved-dialog' ? '[data-saved-open]' : '[data-open-finder]';
            const fallback = $$(selector).find(button => button.getClientRects().length) || $('[data-dsh-mobile-open]');
            on(homeDialog,'close',()=>fallback?.focus({preventScroll:true}),{once:true});
          }
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        const destination = dialogId === 'saved-dialog' ? '#saved-pieces' : '#find-my-match';
        location.assign(route((root.dataset.homeUrl || '/') + destination));
        return;
      }
      if (target.matches('a')) hide();
    });
    const navigationItems = $$('.shop-nav-row nav > [data-dsh-mega],.shop-nav-row nav > a');
    navigationItems.forEach(button => {
      on(button,'pointerenter',event => { if (event.pointerType === 'mouse' && !narrow.matches) { clearTimeout(timer); if (button.hasAttribute('data-dsh-mega')) timer = setTimeout(()=>show(button.dataset.dshMega),180); else hide(); } });
      if (button.matches('a')) on(button,'focus',()=>hide());
      on(button,'keydown',event => {
        if (event.key === 'ArrowDown' && button.hasAttribute('data-dsh-mega')) { event.preventDefault(); show(button.dataset.dshMega,true); }
        if (['ArrowLeft','ArrowRight'].includes(event.key)) { event.preventDefault(); navigationItems[(navigationItems.indexOf(button)+(event.key==='ArrowRight'?1:navigationItems.length-1))%navigationItems.length].focus(); }
      });
    });
    on(header,'pointerenter',()=>clearTimeout(timer));
    on(header,'pointerleave',event=>{ if(event.pointerType==='mouse')timer=setTimeout(()=>{if(!mega.contains(document.activeElement))hide();},300); });
    on(header,'focusout',()=>{clearTimeout(focusTimer);focusTimer=setTimeout(()=>{if(active&&!header.contains(document.activeElement))hide();},0);});
    on(document,'keydown',event=>{if(event.key==='Escape'&&active)hide(true);});
    on(narrow,'change',()=>closeAll());
    [mobile,search].forEach(dialog=>{
      on(dialog,'cancel',event=>{event.preventDefault();closeDialog(dialog);});
      on(dialog,'close',syncDialogLock);
      on(dialog,'click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog(dialog);}});
    });
    if (previewThemeId) {
      $$('form[action]').forEach(form=>{
        if (!form.querySelector('[name="preview_theme_id"]')) {
          const input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';input.value=previewThemeId;form.append(input);
        }
      });
    }
    const measure = () => {
      if (controller.signal.aborted || !root.isConnected) return;
      const bounds=header.getBoundingClientRect();
      root.style.setProperty('--ds-header-height',Math.ceil(bounds.height)+'px');
      root.style.setProperty('--ds-header-bottom',Math.max(0,Math.ceil(bounds.bottom))+'px');
      const bar=document.getElementById('PBarNextFrameWrapper')||document.getElementById('PBarNextFrame');
      const barHeight=bar&&getComputedStyle(bar).display!=='none'?Math.min(200,Math.ceil(bar.getBoundingClientRect().height)):0;
      root.style.setProperty('--ds-preview-toolbar-height',barHeight+'px');
    };
    const resize=new ResizeObserver(measure);resize.observe(header);root.dsResize=resize;
    const toolbarObserver=new MutationObserver(measure);toolbarObserver.observe(document.body,{childList:true});root.dsToolbarObserver=toolbarObserver;
    on(window,'resize',measure);measure();
    on(window,'scroll',()=>{
      if (!active || measureFrame) return;
      measureFrame=requestAnimationFrame(()=>{
        measureFrame=0;
        if(active)measure();
      });
    },{passive:true});
    let homeActionTimer, homeActionExpiry, homeActionObserver;
    const stopHomeAction = () => {
      clearTimeout(homeActionTimer);
      clearTimeout(homeActionExpiry);
      homeActionObserver?.disconnect();
      homeActionObserver = undefined;
    };
    const resumeHomeAction = () => {
      stopHomeAction();
      const destinations = {
        '#saved-pieces': {dialog:'saved-dialog',selector:'[data-saved-open]'},
        '#find-my-match': {dialog:'finder-dialog',selector:'[data-open-finder]'}
      };
      const action = destinations[location.hash];
      if (!action) return;
      const attempt = () => {
        if (controller.signal.aborted || !root.isConnected) { stopHomeAction(); return; }
        const dialog = document.getElementById(action.dialog);
        if (!dialog) return;
        stopHomeAction();
        // Run after the homepage has inserted its markup and bound its handlers.
        homeActionTimer = setTimeout(() => {
          if (!controller.signal.aborted && !dialog.open) $(action.selector)?.click();
        }, 0);
      };
      attempt();
      if (!document.getElementById(action.dialog)) {
        const isHome = location.pathname.replace(/\/$/,'') === (root.dataset.homeUrl || '/').replace(/\/$/,'');
        if (!isHome) return;
        homeActionObserver = new MutationObserver(attempt);
        homeActionObserver.observe(document.getElementById('app') || document.body, {childList:true,subtree:true});
        homeActionExpiry = setTimeout(stopHomeAction, 10000);
      }
    };
    on(window,'hashchange',resumeHomeAction);
    const api={show,hide:()=>closeAll(),reveal:key=>show(key||'engagement-rings',true),route,resumeHomeAction};
    current=api;
    root.dsDestroy=()=>{
      controller.abort();
      stopHomeAction();
      clearTimeout(timer);
      clearTimeout(focusTimer);
      closeAll();
      resize.disconnect();
      toolbarObserver.disconnect();
      syncDialogLock();
      if(current===api)current=undefined;
      delete root.dataset.ready;
      delete root.dsController;
      delete root.dsResize;
      delete root.dsToolbarObserver;
      delete root.dsDestroy;
    };
    resumeHomeAction();
  }
  window.DSHeader={show:(...args)=>current?.show(...args),hide:()=>current?.hide(),reveal:key=>current?.reveal(key),resumeHomeAction:()=>current?.resumeHomeAction()};
  const boot=()=>document.querySelectorAll('[data-ds-shared-header]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event=>{
    const roots=event.target.matches?.('[data-ds-shared-header]')?[event.target]:event.target.querySelectorAll('[data-ds-shared-header]');
    roots.forEach(root=>root.dsDestroy?.());
  });
})();

/* Diamond Studio complimentary studs campaign. Display only; no cart writes. */
(function () {
  'use strict';
  if (window.DSStudGiftPlacements) return;
  window.DSStudGiftConfig = { threshold: 300000, inclusive: true, currency: 'USD' };
  const banner = 'Free Diamond Stud Earrings on Orders of US$3,000 or More';
  const copy = 'Free diamond stud earrings with purchases of US$3,000 or more.';
  function giftPhoto(large = false) {
    const src = document.querySelector('[data-ds-shared-header]')?.dataset.giftImageUrl;
    if (!src) return '';
    const image = document.createElement('img');
    image.src = src; image.alt = 'Complimentary diamond stud earrings';
    image.className = 'ds-gift-photo' + (large ? ' ds-gift-photo--large' : '');
    image.width = image.height = 1200; image.loading = large ? 'eager' : 'lazy'; image.decoding = 'async';
    return image.outerHTML;
  }
  function giftThumbnail() {
    const photo = giftPhoto();
    return photo ? '<button type="button" class="ds-gift-thumb" data-ds-stud-offer aria-label="View complimentary earrings and gift offer" aria-haspopup="dialog" aria-controls="ds-stud-gift-dialog">' + photo + '</button>' : '';
  }
  const icon = '<svg class="ds-gift-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 9h18v4H3zM5 13v8h14v-8M12 9v12M12 9H8a3 3 0 1 1 3-3l1 3Zm0 0h4a3 3 0 1 0-3-3l-1 3Z"/></svg>';
  const styles = `
    .ds-header-root .shop-utility.ds-gift-utility{display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);gap:16px;height:31px}
    .ds-header-root .shop-utility.ds-gift-utility>span:first-child{justify-self:start}
    .ds-header-root .shop-utility.ds-gift-utility>span:last-child{justify-self:end}
    .ds-header-root .shop-utility.ds-gift-utility>.ds-gift-announcement{font-size:11px;font-weight:500;letter-spacing:.01em;text-align:center;white-space:nowrap;line-height:1.4}
    .ds-gift-product,.ds-gift-collection,.ds-gift-cart,.ds-gift-dialog{box-sizing:border-box;font-family:'DM Sans',Arial,sans-serif;color:#263f34}
    .ds-gift-product{display:flex;gap:14px;align-items:flex-start;border:1px solid #dce2d4;background:#eef2e9;padding:18px 20px;margin:18px 0 14px}
    .ds-gift-product .ds-gift-title{font:500 21px/1.15 'Cormorant Garamond',Georgia,serif;margin:0 0 7px;color:#263f34}
    .ds-gift-icon{flex:0 0 22px;margin-top:2px;width:22px;height:22px}
    .ds-gift-product .ds-gift-copy,.ds-gift-cart .ds-gift-copy{font:400 12px/1.65 'DM Sans',Arial,sans-serif;margin:0;color:#4a5c4e}
    .ds-gift-offer-link{appearance:none;background:none;border:0;border-bottom:1px solid #71816f;padding:0 0 2px;color:#304f3c;font:400 11px/1.5 'DM Sans',Arial,sans-serif;cursor:pointer;margin-top:8px}
    .ds-gift-collection{display:flex;align-items:center;gap:12px;padding:15px 0;border-top:1px solid #dce2d4;border-bottom:1px solid #dce2d4;margin:0 0 24px;font-size:13px;line-height:1.6}
    .ds-gift-collection .ds-gift-offer-link{margin:0 0 0 auto;white-space:nowrap}
    .ds-gift-collection .ds-gift-icon{width:19px;height:19px;flex-basis:19px;margin:0}
    .ds-gift-cart{background:#eef2e9;border:1px solid #dce2d4;padding:20px;margin:0 0 20px;text-align:left}
    .ds-gift-cart .ds-gift-eyebrow{display:block;font:500 10px/1.4 'DM Sans',Arial,sans-serif;text-transform:uppercase;letter-spacing:.1em;margin:0 0 12px;color:#4a5c4e}
    .ds-gift-cart .ds-gift-title{font:400 25px/1.12 'Cormorant Garamond',Georgia,serif;margin:0 0 13px;color:#263f34}
    .ds-gift-track{height:4px;background:#dce4d5;margin:16px 0 8px;overflow:hidden}
    .ds-gift-track>span{display:block;height:100%;background:#547447}
    .ds-gift-scale{display:flex;justify-content:space-between;gap:12px;font:400 10px/1.4 'DM Sans',Arial,sans-serif;margin:0 0 12px;color:#586a59}
    .ds-gift-cart [hidden]{display:none!important}
    .ds-gift-dialog{width:min(480px,calc(100% - 36px));max-height:calc(100dvh - 40px);background:#fffefa;border:1px solid #dce2d4;padding:32px;margin:auto;box-shadow:0 20px 80px #16281e26}
    .ds-gift-dialog::backdrop{background:#16281e66}
    .ds-gift-dialog header{display:flex;align-items:start;gap:20px;justify-content:space-between}
    .ds-gift-dialog h2{font:400 32px/1.1 'Cormorant Garamond',Georgia,serif;margin:0;color:#263f34}
    .ds-gift-dialog p{font:400 14px/1.7 'DM Sans',Arial,sans-serif;margin:20px 0 0;color:#4a5c4e}
    .ds-gift-dialog button{background:none;border:1px solid #dce2d4;color:#263f34;width:36px;height:36px;flex:0 0 36px;font-size:22px;cursor:pointer}
    @media(max-width:1100px){.ds-header-root .shop-utility.ds-gift-utility{display:flex;justify-content:center;min-height:31px;height:auto;padding:7px 16px}.ds-header-root .shop-utility.ds-gift-utility>span:not(.ds-gift-announcement){display:none}.ds-header-root .shop-utility.ds-gift-utility>.ds-gift-announcement{font-size:11px;white-space:normal;max-width:100%;display:block}}
    @media(max-width:600px){.ds-gift-product{padding:16px;gap:12px}.ds-gift-product .ds-gift-title{font-size:21px}.ds-gift-collection{align-items:flex-start;flex-wrap:wrap;font-size:12px;gap:10px}.ds-gift-collection>span{flex:1;min-width:0}.ds-gift-collection .ds-gift-offer-link{margin-left:29px}.ds-gift-cart{padding:17px}.ds-gift-cart .ds-gift-title{font-size:24px}.ds-gift-dialog{padding:24px}}
    @media(pointer:coarse){.ds-gift-offer-link{min-height:30px;padding-top:6px}.ds-gift-dialog button{width:44px;height:44px;flex-basis:44px}}
    .ds-header-root .ds-gift-announcement>button{appearance:none;border:0;background:transparent;color:inherit;font:inherit;letter-spacing:inherit;line-height:inherit;cursor:pointer;padding:0;text-align:center}
    .ds-header-root .ds-gift-announcement>button>span{display:inline-block;margin-left:5px}
    .ds-gift-product>div{flex:1;min-width:0}
    .ds-gift-thumb{display:block;flex:0 0 92px;width:92px;align-self:center;padding:0;border:1px solid #dce2d4;background:#fff;cursor:pointer;overflow:hidden}
    .ds-gift-photo{display:block;width:100%;height:auto;aspect-ratio:1.35;object-fit:cover;object-position:center;margin:0}
    .ds-gift-product .ds-gift-thumb:hover,.ds-gift-cart .ds-gift-thumb:hover,.ds-gift-collection .ds-gift-thumb:hover{filter:none}
    .ds-gift-collection>.ds-gift-thumb{flex-basis:68px;width:68px}
    .ds-gift-cart-intro{display:flex;align-items:center;gap:14px}
    .ds-gift-cart-intro>div{flex:1;min-width:0}
    .ds-gift-cart-intro .ds-gift-eyebrow{margin-bottom:6px}
    .ds-gift-cart-intro .ds-gift-title{margin-bottom:0}
    .ds-gift-cart .ds-gift-copy{margin-top:12px}
    html.ds-gift-offer-open{overflow:hidden}
    .ds-gift-dialog{overflow:auto;overscroll-behavior:contain;max-height:calc(100dvh - var(--ds-preview-toolbar-height,0px) - 32px);padding:24px}
    .ds-gift-dialog header{align-items:center;gap:12px}
    .ds-gift-dialog header>button{width:44px;height:44px;flex:0 0 44px;padding:0}
    .ds-gift-dialog h2{font-size:28px}
    .ds-gift-preview{margin:18px 0 0;background:#fff}
    .ds-gift-dialog .ds-gift-photo--large{aspect-ratio:1.5}
    .ds-gift-preview figcaption{font:12px/1.5 'DM Sans',Arial,sans-serif;text-align:center;padding:8px 12px 12px;color:#4a5c4e}
    .ds-gift-dialog p{margin-top:16px}
    .ds-gift-thumb:focus-visible,.ds-gift-offer-link:focus-visible,.ds-gift-announcement>button:focus-visible,.ds-gift-dialog button:focus-visible{outline:2px solid currentColor;outline-offset:3px}
    @media(max-width:600px){.ds-gift-product{padding:14px;gap:12px}.ds-gift-product .ds-gift-title{font-size:20px}.ds-gift-product>.ds-gift-thumb,.ds-gift-cart .ds-gift-thumb{flex-basis:76px;width:76px}.ds-gift-dialog{padding:18px}.ds-gift-dialog h2{font-size:26px}}
  `;
  let dialog, opener;
  function addStyles() {
    if (document.getElementById('ds-stud-gift-style')) return;
    const style = document.createElement('style');
    style.id = 'ds-stud-gift-style'; style.textContent = styles;
    document.head.append(style);
  }
  function showOffer(trigger) {
    if (!dialog) {
      dialog = document.createElement('dialog'); dialog.className = 'ds-gift-dialog'; dialog.id = 'ds-stud-gift-dialog';
      dialog.setAttribute('aria-labelledby', 'ds-stud-gift-heading');
      dialog.setAttribute('aria-describedby', 'ds-stud-gift-description');
      const photo = giftPhoto(true);
      dialog.innerHTML = '<header><h2 id="ds-stud-gift-heading">A gift from the studio.</h2><button type="button" aria-label="Close gift offer">×</button></header>' + (photo ? '<figure class="ds-gift-preview">' + photo + '<figcaption>Your complimentary diamond stud earrings</figcaption></figure>' : '') + '<p id="ds-stud-gift-description">Receive a free pair of diamond stud earrings with qualifying purchases of US$3,000 or more. View your bag for progress toward the offer.</p>';
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { document.documentElement.classList.remove('ds-gift-offer-open'); if (opener?.isConnected) opener.focus({ preventScroll: true }); });
      dialog.addEventListener('click', event => { const r = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close(); });
    }
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('ds-gift-offer-open');
    dialog.querySelector('button').focus();
  }
  function mountHeader() {
    document.querySelectorAll('[data-ds-shared-header] .shop-utility').forEach(bar => {
      if (!bar.querySelector('.ds-gift-announcement')) {
        const text = document.createElement('span'); text.className = 'ds-gift-announcement';
        text.innerHTML = '<button type="button" data-ds-stud-offer aria-haspopup="dialog" aria-controls="ds-stud-gift-dialog">' + banner + '<span aria-hidden="true">→</span></button>';
        bar.insertBefore(text, bar.lastElementChild);
      }
      bar.classList.add('ds-gift-utility');
    });
  }
  function mountProduct() {
    const actions = document.querySelector('#configure #buy-actions');
    if (!actions) return;
    let card = document.getElementById('ds-stud-gift-product');
    if (!card) {
      card = document.createElement('section'); card.id = 'ds-stud-gift-product'; card.className = 'ds-gift-product';
      card.setAttribute('aria-label', 'Complimentary diamond studs offer');
      card.innerHTML = (giftThumbnail() || icon) + '<div><h3 class="ds-gift-title">A little extra brilliance, on us.</h3><p class="ds-gift-copy">' + copy + '</p><button type="button" class="ds-gift-offer-link" data-ds-stud-offer aria-haspopup="dialog" aria-controls="ds-stud-gift-dialog">View gift offer</button></div>';
    }
    if (card.nextElementSibling !== actions) actions.before(card);
  }
  function mountCollections() {
    document.querySelectorAll('[data-ds-collection] .dsc-intro').forEach(intro => {
      if (intro.nextElementSibling?.classList.contains('ds-gift-collection')) return;
      const note = document.createElement('div'); note.className = 'ds-gift-collection';
      note.innerHTML = (giftThumbnail() || icon) + '<span>' + copy + '</span><button type="button" class="ds-gift-offer-link" data-ds-stud-offer aria-haspopup="dialog" aria-controls="ds-stud-gift-dialog">View gift offer →</button>';
      intro.after(note);
    });
  }
  function mount() { addStyles(); mountHeader(); mountProduct(); mountCollections(); }
  document.addEventListener('click', event => { const trigger = event.target.closest?.('[data-ds-stud-offer]'); if (trigger) showOffer(trigger); });
  ['shopify:section:load','ds:collection:updated','ds:selection','gpoRenderCompleted'].forEach(name => document.addEventListener(name, mount));
  window.DSStudGiftPlacements = { mount, thumbnail: giftThumbnail };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
})();

(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document && root.DSStudGiftConfig) api.install(root);
})(typeof window === 'object' ? window : null, function () {
  'use strict';
  const TARGETS = '.ajaxcart__footer, #cart-form .cart-total';
  function money(cents, explicitCurrency) {
    if (!Number.isSafeInteger(cents) || cents < 0) return '';
    const fraction = cents % 100;
    return (explicitCurrency ? 'US$' : '$') + Math.floor(cents / 100).toLocaleString('en-US') + (fraction ? '.' + String(fraction).padStart(2, '0') : '');
  }
  function parseUSD(text) {
    if (typeof text !== 'string') return null;
    const match = text.trim().replace(/\s+/g, ' ').match(/^(?:(US\$|USD)\s*)?\$?\s*((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{2})?)(?:\s*(USD))?$/);
    if (!match || (!match[1] && !match[3])) return null;
    const [whole, fraction = '00'] = match[2].replace(/,/g, '').split('.');
    const cents = Number(whole) * 100 + Number(fraction);
    return Number.isSafeInteger(cents) && cents >= 0 ? cents : null;
  }
  function compute(cart, config) {
    const threshold = config && config.threshold;
    if (!Number.isSafeInteger(threshold) || threshold < 1 || threshold >= Number.MAX_SAFE_INTEGER || config.currency !== 'USD') return { kind: 'disabled' };
    const inclusive = config.inclusive === true;
    const copy = 'Free diamond stud earrings with purchases ' + (inclusive ? 'of ' : 'over ') + money(threshold, true) + (inclusive ? ' or more.' : '.');
    const neutral = { kind: 'unknown', eyebrow: 'A gift from the studio', title: 'A little extra brilliance, on us.', copy };
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return neutral;
    if (cart.currency !== config.currency) return Object.assign({}, neutral, { kind: 'currency' });
    if (!cart.items.length) return Object.assign({}, neutral, { kind: 'empty' });
    const goal = threshold + (inclusive ? 0 : 1);
    const total = cart.total_price;
    const qualifies = total >= goal;
    return {
      kind: qualifies ? 'qualified' : 'progress',
      eyebrow: qualifies ? 'Your gift awaits' : neutral.eyebrow,
      title: qualifies ? 'Your order qualifies for free diamond studs.' : "You're " + money(goal - total) + ' away from free diamond studs.',
      copy,
      total, goal, percent: Math.min(100, total / goal * 100),
      currentLabel: money(total),
      goalLabel: qualifies ? 'Gift threshold reached' : money(goal),
      progressLabel: qualifies ? 'Gift threshold reached' : money(total) + ' toward ' + money(goal)
    };
  }
  function install(win) {
    if (win.DSStudGiftCart) return win.DSStudGiftCart;
    const doc = win.document, config = win.DSStudGiftConfig;
    if (!doc || compute(null, config).kind === 'disabled') return null;
    let mountedQueued = false;
    function targets() { return Array.from(doc.querySelectorAll(TARGETS)); }
    function visibleCart(target) {
      const text = target.querySelector('.cart-total__subtotal-price, .cart-modal-totalprice')?.textContent?.trim() || '';
      const total = parseUSD(text);
      if (total === null) return null;
      const form = target.closest('form');
      const hasItems = !!form?.querySelector('.item-cart[data-line], .ajaxcart__product[data-line]');
      if (!hasItems && total !== 0) return null;
      return { currency: 'USD', total_price: total, items: hasItems ? [{}] : [] };
    }
    function ensurePanel(target) {
      let panel = target.querySelector('[data-ds-gift-cart]');
      if (panel) return panel;
      panel = doc.createElement('section');
      panel.className = 'ds-gift-cart'; panel.setAttribute('data-ds-gift-cart', ''); panel.setAttribute('aria-label', 'Diamond stud gift offer');
      panel.innerHTML = '<div class="ds-gift-cart-intro">' + (win.DSStudGiftPlacements?.thumbnail() || '') + '<div><span class="ds-gift-eyebrow"></span><h3 class="ds-gift-title" aria-live="polite"></h3></div></div><div class="ds-gift-track" role="progressbar" aria-label="Progress toward free diamond studs" hidden><span></span></div><div class="ds-gift-scale" hidden><span></span><span></span></div><p class="ds-gift-copy"></p><button type="button" class="ds-gift-offer-link" data-ds-stud-offer aria-haspopup="dialog" aria-controls="ds-stud-gift-dialog">View gift offer</button>';
      const subtotal = target.querySelector('.ajaxcart__subtotal, .cart-total__subtotal');
      target.insertBefore(panel, subtotal || target.firstChild);
      return panel;
    }
    function render() {
      for (const target of targets()) {
        // This display-only promotion mirrors the subtotal the cart itself currently shows.
        // It neither reads cart APIs nor participates in app reconciliation or cart writes.
        const state = compute(visibleCart(target), config);
        const signature = JSON.stringify(state);
        const panel = ensurePanel(target);
        if (panel.getAttribute('data-gift-state') === signature) continue;
        panel.setAttribute('data-gift-state', signature);
        panel.hidden = state.kind === 'empty' || state.kind === 'disabled';
        panel.querySelector('.ds-gift-eyebrow').textContent = state.eyebrow || '';
        panel.querySelector('.ds-gift-title').textContent = state.title || '';
        panel.querySelector('.ds-gift-copy').textContent = state.copy || '';
        const track = panel.querySelector('.ds-gift-track'), scale = panel.querySelector('.ds-gift-scale');
        const numeric = state.kind === 'progress' || state.kind === 'qualified';
        track.hidden = scale.hidden = !numeric;
        if (numeric) {
          track.setAttribute('aria-valuemin', '0'); track.setAttribute('aria-valuemax', String(state.goal));
          track.setAttribute('aria-valuenow', String(Math.min(state.total, state.goal))); track.setAttribute('aria-valuetext', state.progressLabel);
          track.firstElementChild.style.width = state.percent + '%';
          scale.firstElementChild.textContent = state.currentLabel; scale.lastElementChild.textContent = state.goalLabel;
        } else {
          ['aria-valuemin', 'aria-valuemax', 'aria-valuenow', 'aria-valuetext'].forEach(name => track.removeAttribute(name));
          track.firstElementChild.style.width = '0%';
          scale.firstElementChild.textContent = scale.lastElementChild.textContent = '';
        }
      }
    }
    function paint() { try { render(); } catch (_) { /* Offer rendering must never interrupt the cart. */ } }
    function queuePaint() {
      if (mountedQueued) return;
      mountedQueued = true;
      win.queueMicrotask(() => { mountedQueued = false; paint(); });
    }
    function start() {
      paint();
      if (win.MutationObserver) new win.MutationObserver(queuePaint).observe(doc.body, { childList: true, characterData: true, subtree: true });
    }
    const api = { refresh: paint, compute: cart => compute(cart, config), get state() { return { source: 'rendered-cart', carts: targets().map(visibleCart) }; } };
    win.DSStudGiftCart = api;
    win.addEventListener('pageshow', queuePaint);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    return api;
  }
  return { compute, install, money, parseUSD };
});
